<template>
  <div>
    <Overlay v-if="cargando" />
    <div class="lugar">
      <div
        v-if="lugar.lugar.ciudad === 'juarez'"
        class="container-fluid"
      >
        <div class="row justify-content-center pt-4 mb-2">
          <img
            :src="lugar.lugar.logo"
            alt="Lugar"
            class="imagen-banner"
          >
        </div>
        <div class="row mt-2">
          <h2 class=" titulo-lugar-juarez">{{lugar.nombre}}</h2>
        </div>
        <div class="row mb-2">
          <span>{{lugar.lugar.sub_categorias?lugar.lugar.sub_categorias[0] : ''}}</span>
        </div>
        <div class="row mb-4">
          <div class="col-7">
            <span v-html="lugar.lugar.descripcion"></span>
          </div>
          <div class="col-5">
            <!-- <div class="row">
              <div class="col">
                <h3 class="titulo-lugar-juarez">Distancia: </h3>
              </div>
              <div class="col">2.3 Km</div>
            </div> -->
            <div class="row">
              <div class="titulo-lugar-juarez">Horario: </div>
              <div
                v-for="(horario, dia) in lugar.sucursales[0].horario"
                :key="dia"
                class="col-12"
              >
                <span v-if="!horario.value">{{dia}}: Cerrado</span>
                <span v-if="horario.value">{{dia}}: {{horario.start}} - {{horario.end}}</span>
              </div>
            </div>
            <div class="row align-items-center mt-20">
              <div class="col">
                <h3 class="titulo-lugar-juarez">Contacto:</h3>
              </div>
              <div class="col">
                <div class="row">
                  <i class="fas fa-phone"></i>
                  <span>{{lugar.sucursales[0].telefono ? lugar.sucursales[0].telefono : 'Sin telefono asignado'}}</span>
                </div>
                <div
                  class="row"
                  v-for="(link, red) in lugar.lugar.redes"
                  :key="red"
                >
                  <i
                    class="fab fa-facebook-square"
                    v-if="link.name === 'facebook'"
                  ></i>
                  <i
                    class="fab fa-instagram"
                    v-if="link.name === 'instagram'"
                  ></i>
                  <i
                    class="fab fa-twitter"
                    v-if="link.name === 'twitter'"
                  ></i>
                  <i
                    class="fas fa-globe"
                    v-if="link.name === 'website'"
                  ></i>
                  <i
                    class="fas fa-ticket-alt"
                    v-if="link.name === 'boletos'"
                  ></i>
                  <i
                    class="fas fa-calendar-day"
                    v-if="link.name === 'reservaciones'"
                  ></i>
                  <span>{{link.link}}</span>
                </div>
              </div>
            </div>
          </div>
          <modal
            :foto="cover"
            @close-modal="modal=false"
            v-if="modal"
          />
          <div class="row mt-4">
            <h2 class=" titulo-lugar-juarez">Galeria: </h2>
          </div>
          <div class="container">
            <div class="row gallery-juarez">
              <div class="col">
                <slick
                  ref="slick"
                  :options="slickOptions"
                  @beforeChange="handleBeforeChange"
                >
                  <div
                    v-for="(item,key) in lugar.lugar.galeria"
                    :key="key"
                    @click="showModal(item)"
                  >
                    <img
                      :src="item"
                      :alt="lugar.nombre"
                      class="gallery-slides"
                    >
                  </div>
                </slick>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="lugar.lugar.ciudad === 'el-paso'"
        class="container-fluid"
      >
        <div class="row justify-content-center pt-4 mb-2">
          <img
            :src="lugar.lugar.logo"
            alt="Lugar"
            class="imagen-banner"
          >
        </div>
        <div class="row mt-2">
          <h2 class=" titulo-lugar-el-paso">{{lugar.nombre}}</h2>
        </div>
        <div class="row mb-2">
          <span>{{lugar.lugar.sub_categorias?lugar.lugar.sub_categorias[0] : ''}}</span>
        </div>
        <div class="row mb-4">
          <div class="col-7">
            <span v-html="lugar.lugar.descripcion"></span>
          </div>
          <div class="col-5">
            <!-- <div class="row">
              <div class="col">
                <h3 class="titulo-lugar-el-paso">Distancia: </h3>
              </div>
              <div class="col">2.3 Km</div>
            </div> -->
            <!-- <div class="row">
              <div class="col">
                <h3 class="titulo-lugar-el-paso">Horario: </h3>
              </div>
              <div class="col">
                <span>{{lugar.horario}}</span>
              </div>
            </div> -->
            <div class="row">
              <div class="titulo-lugar-juarez">Horario: </div>
              <div
                v-for="(horario, dia) in lugar.sucursales[0].horario"
                :key="dia"
                class="col-12"
              >
                <span v-if="!horario.value">{{dia}}: Cerrado</span>
                <span v-if="horario.value">{{dia}}: {{horario.start}} - {{horario.end}}</span>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <h3 class="titulo-lugar-el-paso">Contacto:</h3>
              </div>
              <div class="col">
                <div class="row">
                  <i class="fas fa-phone"></i>
                  <span>{{lugar.sucursales[0].telefono ? lugar.sucursales[0].telefono : 'Sin telefono asignado'}}</span>
                </div>
                <div
                  class="row"
                  v-for="(link, red) in lugar.lugar.redes"
                  :key="red"
                >
                  <i
                    class="fab fa-facebook-square"
                    v-if="link.name === 'facebook'"
                  ></i>
                  <i
                    class="fab fa-instagram"
                    v-if="link.name === 'instagram'"
                  ></i>
                  <i
                    class="fab fa-twitter"
                    v-if="link.name === 'twitter'"
                  ></i>
                  <i
                    class="fas fa-globe"
                    v-if="link.name === 'website'"
                  ></i>
                  <i
                    class="fas fa-ticket-alt"
                    v-if="link.name === 'boletos'"
                  ></i>
                  <i
                    class="fas fa-calendar-day"
                    v-if="link.name === 'reservaciones'"
                  ></i>
                  <span>{{link.link}}</span>
                </div>
              </div>
            </div>
          </div>
          <modal
            :foto="cover"
            @close-modal="modal=false"
            v-if="modal"
          />
          <div class="row mt-4">
            <h2 class=" titulo-lugar-el-paso">Galeria: </h2>
          </div>
          <div class="container">
            <div class="row gallery-el-paso">
              <div class="col">
                <slick
                  ref="slick"
                  :options="slickOptions"
                >
                  <div
                    v-for="(item,key) in lugar.lugar.galeria"
                    :key="key"
                    @click="showModal(item)"
                  >
                    <img
                      :src="item"
                      :alt="lugar.nombre"
                      class="gallery-slides"
                    >
                  </div>
                </slick>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="lugar.lugar.ciudad === 'las-cruces'"
        class="container-fluid"
      >
        <div class="row justify-content-center pt-4 mb-2">
          <img
            :src="lugar.lugar.logo"
            alt="Lugar"
            class="imagen-banner"
          >
        </div>
        <div class="row mt-2">
          <h2 class=" titulo-lugar-las-cruces">{{lugar.nombre}}</h2>
        </div>
        <div class="row mb-2">
          <span>{{lugar.lugar.sub_categorias?lugar.lugar.sub_categorias[0] : ''}}</span>
        </div>
        <div class="row mb-4">
          <div class="col-7">
            <span v-html="lugar.lugar.descripcion"></span>
          </div>
          <div class="col-5">
            <!-- <div class="row">
              <div class="col">
                <h3 class="titulo-lugar-las-cruces">Distancia: </h3>
              </div>
              <div class="col">2.3 Km</div>
            </div> -->
            <!-- <div class="row">
              <div class="col">
                <h3 class="titulo-lugar-las-cruces">Horario: </h3>
              </div>
              <div class="col">
                <span>{{lugar.horario}}</span>
              </div>
            </div> -->
            <div class="row">
              <div class="titulo-lugar-juarez">Horario: </div>
              <div
                v-for="(horario, dia) in lugar.sucursales[0].horario"
                :key="dia"
                class="col-12"
              >
                <span v-if="!horario.value">{{dia}}: Cerrado</span>
                <span v-if="horario.value">{{dia}}: {{horario.start}} - {{horario.end}}</span>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <h3 class="titulo-lugar-las-cruces">Contacto:</h3>
              </div>
              <div class="col">
                <div class="row">
                  <i class="fas fa-phone"></i>
                  <span>{{lugar.sucursales[0].telefono ? lugar.sucursales[0].telefono : 'Sin telefono asignado'}}</span>
                </div>
                <div
                  class="row"
                  v-for="(link, red) in lugar.lugar.redes"
                  :key="red"
                >
                  <i
                    class="fab fa-facebook-square"
                    v-if="link.name === 'facebook'"
                  ></i>
                  <i
                    class="fab fa-instagram"
                    v-if="link.name === 'instagram'"
                  ></i>
                  <i
                    class="fab fa-twitter"
                    v-if="link.name === 'twitter'"
                  ></i>
                  <i
                    class="fas fa-globe"
                    v-if="link.name === 'website'"
                  ></i>
                  <i
                    class="fas fa-ticket-alt"
                    v-if="link.name === 'boletos'"
                  ></i>
                  <i
                    class="fas fa-calendar-day"
                    v-if="link.name === 'reservaciones'"
                  ></i>
                  <span>{{link.link}}</span>
                </div>
              </div>
            </div>
          </div>
          <modal
            :foto="cover"
            @close-modal="modal=false"
            v-if="modal"
          />
          <div class="row mt-4">
            <h2 class=" titulo-lugar-las-cruces">Galeria: </h2>
          </div>
          <div class="container">
            <div class="row gallery-las-cruces">
              <div class="col">
                <slick
                  ref="slick"
                  :options="slickOptions"
                >
                  <div
                    v-for="(item,key) in lugar.lugar.galeria"
                    :key="key"
                    @click="showModal(item)"
                  >
                    <img
                      :src="item"
                      :alt="lugar.nombre"
                      class="gallery-slides"
                    >
                  </div>
                </slick>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="js">
import http from '@/helpers/http'
import Overlay from '@/helpers/Overlay'
import slick from 'vue-slick'
import '../../../node_modules/slick-carousel/slick/slick.css'
// import '../../../node_modules/slick-carousel/slick/slick-theme.css'
import modal from './modal.vue'
export default {
  name: 'lugar',
  props: [],
  components: {
    Overlay,
    slick,
    modal
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.getLugar()
    })
  },
  data () {
    return {
      lugar: {},
      info: false,
      cargando: true,
      modal: false,
      cover: null,
      polyline: '',
      slickOptions: {
        centerPadding: '60px',
        slidesToShow: 3,
        arrow: false
      }
    }
  },
  computed: {

  },
  mounted () {
    // this.reInit()
  },
  watch: {
    '$route.params': {
      deep: true,
      immediate: true,
      handler (value) {
        this.getLugar()
      }
    },
    lugar: {
      immediate: true,
      deep: true,
      handler (value) {
        if (!value.sucursales[0].horario) {
          value.sucursales[0].horario = {
            lunes: {
              value: null,
              start: '07:00',
              end: '15:00'
            },
            martes: {
              value: null,
              start: null,
              end: null
            },
            miercoles: {
              value: null,
              start: null,
              end: null
            },
            jueves: {
              value: null,
              start: null,
              end: null
            },
            viernes: {
              value: null,
              start: null,
              end: null
            },
            sabado: {
              value: null,
              start: null,
              end: null
            },
            domingo: {
              value: null,
              start: null,
              end: null
            }
          }
        }
      }
    }
  },
  methods: {
    getLugar () {
      let vm = this
      if (this.$route.params.tipo === 'eventos') {
        http.get('/eventos/' + this.$route.params.hash).then(res => {
          this.lugar = res.data
          this.cargando = false
        }, err => {
          console.log(err)
        })
        return
      }
      if (this.$route.params.tipo === 'turibus') {
        http.get('/turibus/' + this.$route.params.hash).then(res => {
          this.lugar = res.data
          this.cargando = false
        }, err => {
          console.log(err)
        })
      }
      http.get('/lugares/' + this.$route.params.hash).then(res => {
        vm.lugar = res.data
        this.cargando = false
        this.reInit()
      }, err => {
        console.log(err)
      }, this)
    },
    reInit () {
      // Helpful if you have to deal with v-for to update dynamic lists
      this.$nextTick(() => {
        this.$refs.slick.reSlick()
      })
    },
    handleBeforeChange (event, slick, currentSlide, nextSlide) {
      this.cover = currentSlide
    },
    showModal (foto) {
      this.cover = foto
      this.modal = true
    }
  }
}
</script>

<style lang="scss" scoped>
.lugar {
  color: #5e5e5e;
  overflow: auto;
  height: 90vh;

  .imagen-banner {
    object-fit: cover;
    width: 100%;
    height: 20vh;
  }

  .titulo-lugar-juarez {
    color: #6f0f49;
    font-weight: bold;
  }

  .titulo-lugar-el-paso {
    color: #166073;
    font-weight: bold;
  }

  .titulo-lugar-las-cruces {
    color: #ee6225;
    font-weight: bold;
  }

  .texto-lugar {
    color: black;
    font-weight: bold;
    font-size: 1em;
  }

  .gallery-juarez {
    background-color: rgba($color: #6f0f49, $alpha: 0.5);
  }

  .gallery-el-paso {
    background-color: rgba($color: #166073, $alpha: 0.5);
  }

  .gallery-las-cruces {
    background-color: rgba($color: #ee6225, $alpha: 0.5);
  }

  .gallery-slides {
    object-fit: cover;
    height: 25vh;
    width: 100%;
  }
}
</style>
